<template>
    <div id="app">
        <!--导航栏-->
        <div class="navWrap">
            <el-row type="flex" justify="space-between" align="middle">
                <el-col :span="3"></el-col>
                <el-col :span="18" style="max-width: 1440px">
                    <el-row type="flex" justify="space-between" align="center">
                        <el-col :span="2">
                            <img src="./assets/img/nav/logo.svg" alt="" class="logo"/>
                        </el-col>
                        <el-col :span="11">
                            <ul>
                                <li @click="navClick('advantage')">{{isZh ? "服务优势" : "Service advantage"}}</li>
                                <li @click="navClick('successExample')">{{isZh ? "成功案例" : "Case"}}</li>
                                <li @click="navClick('cooperation')">{{isZh ? "合作伙伴" : "Cooperation"}}</li>
                                <li @click="navClick('contact')">{{isZh ? "联系我们" : "contact us"}}</li>
                                <li>
                                    <span :class="navIndex === '/' ? 'active':''"
                                          @click="toPage('/')">
                                        {{isZh ? "中" : "CN"}}
                                    </span>
                                    <span class="line"></span>
                                    <span :class="navIndex === '/indexEn' ? 'active':''"
                                          @click="toPage('/indexEn')">
                                        {{isZh ? "英" : "EN"}}
                                    </span>
                                </li>
                            </ul>
                        </el-col>
                    </el-row>
                </el-col>
                <el-col :span="3"></el-col>
            </el-row>
        </div>
        <!--页面-->
        <router-view/>
    </div>
</template>

<script>
    export default {
        data() {
            return {
                navIndex: "/",
                /*导航映射对象*/
                navObj: {
                    advantage() {
                        const top = document.getElementsByClassName("page")[0].offsetTop;
                        window.scrollTo({
                            top,
                            behavior: "smooth"
                        })
                    },
                    successExample() {
                        const top = document.getElementsByClassName("page")[6].offsetTop;
                        window.scrollTo({
                            top,
                            behavior: "smooth"
                        })
                    },
                    cooperation() {
                        const top = document.getElementsByClassName("page")[7].offsetTop;
                        window.scrollTo({
                            top,
                            behavior: "smooth"
                        })
                    },
                    contact() {
                        const top = document.getElementsByClassName("page")[8].offsetTop;
                        window.scrollTo({
                            top,
                            behavior: "smooth"
                        })
                    }
                },
                isZh: true
            }
        },
        watch: {
            $route(val) {
                this.navIndex = val.path;
                if (val.path === "/indexEn") {
                    this.isZh = false;
                    return
                }
                this.isZh = true;
            }
        },
        methods: {
            toPage(path) {
                this.$router.push({path});
            },
            navClick(className) {
                this.navObj[className]();
            }
        }
    }
</script>

<style lang="scss">
    #app {
        overflow: hidden;
        font-family: Avenir, Helvetica, Arial, sans-serif;
        -webkit-font-smoothing: antialiased;
        -moz-osx-font-smoothing: grayscale;
        text-align: center;
    }

    * {
        margin: 0;
        padding: 0;
        box-sizing: border-box;
    }

    ul, li {
        list-style: none;
    }

    .navWrap {
        padding-top: 24px;
        height: 45px;
        background: black;

        .logo {
            width: 100%;
        }

        ul {
            display: flex;
            align-items: center;
            justify-content: space-between;

            li {
                display: flex;
                align-items: center;
                font-size: 16px;
                letter-spacing: 0.27px;
                color: #FFFFFF;
                cursor: pointer;

                &:last-child {
                    margin-right: 0;
                }

                span {
                    opacity: 0.4;
                }

                .line {
                    width: 1px;
                    height: 6px;
                    background: #fff;
                    margin: 0 8px;
                }

                .active {
                    opacity: 1;
                }
            }
        }
    }
</style>
